
export const STATUS: {[key:string] : string } = {
    PENDING : 'PENDING',
    IN_PROGRESS : 'IN_PROGRESS',
    RECEIVED : 'RECEIVED',
    DONE : 'DONE',
    COMPLETED : 'COMPLETED'
  }